module.exports = __webpack_public_path__ + "static/media/cert_60.1f7467dc.jpg";